import { render, staticRenderFns } from "./examination-paper-info-modal.vue?vue&type=template&id=70345f60&scoped=true"
import script from "./examination-paper-info-modal.vue?vue&type=script&lang=js"
export * from "./examination-paper-info-modal.vue?vue&type=script&lang=js"
import style0 from "./examination-paper-info-modal.vue?vue&type=style&index=0&id=70345f60&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70345f60",
  null
  
)

export default component.exports